import { render, staticRenderFns } from "./AllowMessages.vue?vue&type=template&id=440fb71c&scoped=true&"
import script from "./AllowMessages.vue?vue&type=script&lang=js&"
export * from "./AllowMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440fb71c",
  null
  
)

export default component.exports